// Style
import { brown, cyan, deepOrange, green, grey, lightBlue, lime, orange, pink, red, yellow } from "@mui/material/colors/index.js";

export const trainingFocusColor = [
	green[500],         // Kraft
	orange[500],        // Ausdauer
	pink[300],          // Technik
	yellow["600"],      // Taktik
	cyan["A200"],       // Koord.
	lime[500],          // Schnelligkeit
	deepOrange["A400"], // Wettkampf/Liga
	lightBlue["A200"],  // Ruhetag
	lightBlue["A700"],  // Reisetag
	brown[400],         // Sonstige Aktivität
	grey[300]           // Training
];

//hellere Farben für Darstellung der Dauer in der Analyse
export const analysisDurationColor = [
	green["A100"],      
	orange["A100"],     
	pink["A100"],       
	yellow["A100"],     
	cyan["A100"],       
	lime["A100"],       
	deepOrange["A100"], 
	lightBlue["A100"],  
	lightBlue["A100"],  
	brown[200],         
	grey[300]          
];

//dunklere Farben für Darstellung der Intensität in der Analyse
export const analysisIntensityColor = [
	green["A700"],
	orange["A700"],
	pink["A400"],
	yellow["A700"],
	cyan["A700"],
	lime["A700"],
	deepOrange["A700"],
	lightBlue["A700"],
	brown[600],
	grey[300]
];

export const analysisButtonBackgroundColor = orange[50];
export const bgColorLight = "#fffced";    //Hintergrundfarbe für Athletenliste
export const bgColorToday = 'lightgreen';
export const borderRadius = '50%';
export const borderStyle = '0';
export const primaryColor= red[900];
export const primaryColorLight = red[600];
export const selectedWeekFontColor = green[500];

export const defaultColorScheme = {
	analysisDurationColor,
	analysisIntensityColor,
	analysisButtonBackgroundColor,
	bgColorLight,
	bgColorToday,
	borderRadius,
	borderStyle,
	primaryColor,
	primaryColorLight,
	selectedWeekFontColor,
	trainingFocusColor
};